import useIsErrorPage from '@hooks/useIsErrorPage'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface StyledMainWrapperProps {
  isErrorPage: boolean
}

const StyledMainWrapper = styled.main<StyledMainWrapperProps>`
  ${({ isErrorPage }) => css`
    display: grid;
    align-content: flex-start;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    grid-gap: 20px;
    box-sizing: border-box;
    > * {
      grid-column: span 6;
    }

    ${isErrorPage &&
    css`
      padding-top: 40px;

      ${desktopCSS(css`
        min-height: calc(100vh - 110px - 542px);
      `)}

      ${tabletCSS(
        css`
          min-height: calc(100vh - 110px - 555px - 60px);
        `
      )}

      ${mobileCSS(
        css`
          min-height: calc(100vh - 98px - 650px - 60px);
        `
      )}
    `}

    ${!isErrorPage &&
    css`
      ${desktopCSS(css`
        min-height: calc(100vh - 110px);
      `)}

      ${tabletCSS(
        css`
          min-height: calc(100vh - 110px);
        `
      )}

      ${mobileCSS(
        css`
          min-height: calc(100vh - 98px);
        `
      )}
    `}
  `}
`

const MainWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const isErrorPage = useIsErrorPage()
  return (
    <StyledMainWrapper isErrorPage={isErrorPage}>{children}</StyledMainWrapper>
  )
}

export default MainWrapper
